module.exports = __webpack_public_path__ + "img/place.cdf13fa3.png";